import React, { useContext } from "react";
import { useTranslator } from "@eo-locale/react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  Heading,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Button,
  Text
} from "@/storybook-components";

import { EsriContext } from "../../context/esri-context";
import { useAppDispatch } from "@/redux/store/hooks";
import {
  resetMarkerError,
  resetMarker
} from "@/redux/features/place-marker/slice";
import { resetFilterCategories } from "@/redux/features/place-markers/slice";
import { setView } from "@/redux/features/place-right-panel/slice";
import { setPinDetails } from "@/redux/features/place/slice";
import { resetAnswers, clearAllErrors } from "@/redux/features/questions/slice";

const UnsavedChangesModal = () => {
  const { closeUnsavedModal, isUnsavedModalOpen, handleNextClick } =
    useContext(EsriContext);
  const dispatch = useAppDispatch();
  const { translate } = useTranslator();

  const handleProceed = async () => {
    await dispatch(resetFilterCategories());
    await dispatch(resetAnswers());
    await dispatch(clearAllErrors());
    await dispatch(resetMarkerError());
    await dispatch(setView("activity-feed"));
    await dispatch(resetMarker());
    await dispatch(setPinDetails({}));

    // It should be called after all the above dispatches
    handleNextClick();
  };

  return (
    <Modal isOpen={isUnsavedModalOpen} onClose={closeUnsavedModal} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader></ModalHeader>
        <ModalBody>
          <Heading as="h1" size="lg" fontSize="1.125rem">
            {translate("common.unsavedModalTitle")}
          </Heading>
          <Text fontSize="0.875rem" mt="1rem" mb="2rem">
            {translate("common.unsavedModalBody")}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={closeUnsavedModal} mr="1.6rem">
            {translate("common.cancel")}
          </Button>
          <Button variant="primary" onClick={handleProceed}>
            {translate("common.proceed")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UnsavedChangesModal;
